import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {DraftMessageModel} from '../../../../../../models/api/messageModel';
import {AppState} from '../../../../../../store/appState';
import {makeGetConversationTeamInboxes} from '../../../../../../store/data/conversations/conversationsSelectors';
import {getConversations} from '../../../../../../store/data/dataSelectors';
import {makeGetCanReplyToMessage} from '../../../../../../store/data/messages/messagesSelectors';
import {makeGetConversationParticipants} from '../../../../../../store/data/teammates/mentionTeammatesSelectors';
import {getUserId} from '../../../../../../store/data/teammates/teammatesSelectors';
import {getHasAutoShareDrafts} from '../../../../../../store/featureFlags/featureFlagsSelectors';
import {ComposerPanelId, ViewerPanelId} from '../../../../../../store/panels/panelStateBase';
import {DraftMessageBanner} from './draftMessageBanner';

/*
 * Props.
 */

interface DraftMessageBannerContainerProps {
  message: DraftMessageModel;
  panelId: ComposerPanelId | ViewerPanelId;
}

/*
 * Selectors.
 */

function getMessage(_state: AppState, props: DraftMessageBannerContainerProps) {
  return props.message;
}

function makeGetConversation() {
  return createSelector(
    [getConversations, getMessage],
    (conversations, message) => conversations[message.conversationId],
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DraftMessageBannerContainerProps>()(() => {
  const getConversation = makeGetConversation();

  return {
    teamInboxes: makeGetConversationTeamInboxes(getConversation),
    participants: makeGetConversationParticipants(getConversation),
    canReplyToMessage: makeGetCanReplyToMessage(getMessage),
    userId: getUserId,
    hasAutoShareDrafts: getHasAutoShareDrafts,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<DraftMessageBannerContainerProps>()(() => ({}));

export const DraftMessageBannerContainer = connect(mapStateToProps, mapDispatchToProps)(DraftMessageBanner);
